<template>
  <!-- 左侧侧边栏 -->
  <aside class="sidebar">
    <!-- Logo 区域 -->
    <div class="sidebar-logo">
      <div class="logo-circle">
        <img :src="config.silte_logo" alt="">
      </div>
    </div>

    <!-- 导航菜单 -->
    <div class="sidebar-menu">
      <!-- 全部课程 - 权限1显示 -->
      <div v-if="checkAuth(1)">
        <div class="menu-title">全部课程</div>
        <div class="menu-item" :class="{ active: activeMenu === '首页' }" @click="goRouter('首页','/home')">
          <img src="@/assets/home.png" alt="">
          <span>首页</span>
        </div>
        <div class="menu-container">
          <!-- 递归渲染分类 -->
          <div v-for="(item, index) in cate" :key="item.id || index">
            <!-- 一级分类 -->
            <div class="menu-item" :class="{ active: cateids === item.id }" @click="cateEvent(item, 1, 'first')">
              <img :src="item.cover" alt="">
              <span>{{ item.name }}</span>
              <span v-if="item.sub && item.sub.length" class="arrow" :class="{ expanded: item.isExpanded }">
                ▶
              </span>
            </div>
            <!-- 二级分类 -->
            <transition name="slide">
              <div v-show="item.isExpanded" v-if="item.sub && item.sub.length" class="sub-menu">
                <div v-for="(subItem, subIndex) in item.sub" :key="subItem.id || subIndex">
                  <div class="menu-item sub-item" :class="{ active: cateids === subItem.id }"
                       @click.stop="cateEvent(subItem, 2, 'second', item)">
                    <img :src="subItem.cover" alt="">
                    <span>{{ subItem.name }}</span>
                    <span v-if="subItem.sub && subItem.sub.length" class="arrow"
                          :class="{ expanded: subItem.isExpanded }">
                      ▶
                    </span>
                  </div>
                  <!-- 三级分类 -->
                  <transition name="slide">
                    <div v-show="subItem.isExpanded" v-if="subItem.sub && subItem.sub.length" class="sub-menu">
                      <div
                          class="menu-item sub-item level-3"
                          v-for="(thirdItem, thirdIndex) in subItem.sub"
                          :key="thirdItem.id || thirdIndex"
                          :class="{ active: cateids === thirdItem.id }"
                          @click.stop="cateEvent(thirdItem, 3, 'third', subItem)"
                      >
                        <img :src="thirdItem.cover" alt="">
                        <span>{{ thirdItem.name }}</span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <!-- 学习路线 我的课程 - 权限1显示 -->
      <div class="menu-section" v-if="checkAuth(1)">
        <div class="menu-title">我的课程</div>
        <div
            class="menu-item"
            v-for="item in collectCateList"
            :key="item.id"
            :class="{ active: activeMenu  === item.name }"
            @click="goStudyPath(item)"
        >
          <span>{{ item.name }}</span>
        </div>
      </div>
      <!--培训 -->
      <div class="menu-section">
        <div class="menu-title">培训</div>
        <!--        <div class="menu-item" :class="{ active: activeMenu === '培训教学' }" @click="goRouter('培训教学','/training')">-->
        <!--          <img src="@/assets/training.png" alt="">-->
        <!--          <span>培训教学</span>-->
        <!--        </div>-->
        <div class="menu-container">
          <!-- 递归渲染分类 -->
          <div v-for="(item, index) in trainingCateData" :key="item.id || index">
            <!-- 一级分类 -->
            <div class="menu-item" :class="{ active: trainingCateId === item.id }"
                 @click="trainingCateEvent(item, 1, 'first')">
              <img v-if="item.cover" :src="item.cover" alt="">
              <span>{{ item.name }}</span>
              <span v-if="item.sub && item.sub.length" class="arrow" :class="{ expanded: item.isExpanded }">
                ▶
              </span>
            </div>
            <!-- 二级分类 -->
            <transition name="slide">
              <div v-show="item.isExpanded" v-if="item.sub && item.sub.length" class="sub-menu">
                <div v-for="(subItem, subIndex) in item.sub" :key="subItem.id || subIndex">
                  <div class="menu-item sub-item" :class="{ active: trainingCateId === subItem.id }"
                       @click.stop="trainingCateEvent(subItem, 2, 'second', item)">
                    <img v-if="subItem.cover"  :src="subItem.cover" alt="">
                    <span>{{ subItem.name }}</span>
                    <span v-if="subItem.sub && subItem.sub.length" class="arrow"
                          :class="{ expanded: subItem.isExpanded }">
                      ▶
                    </span>
                  </div>
                  <!-- 三级分类 -->
                  <transition name="slide">
                    <div v-show="subItem.isExpanded" v-if="subItem.sub && subItem.sub.length" class="sub-menu">
                      <div
                          class="menu-item sub-item level-3"
                          v-for="(thirdItem, thirdIndex) in subItem.sub"
                          :key="thirdItem.id || thirdIndex"
                          :class="{ active: trainingCateId === thirdItem.id }"
                          @click.stop="trainingCateEvent(thirdItem, 3, 'third', subItem)"
                      >
                        <img v-if="thirdItem.cover" :src="thirdItem.cover" alt="">
                        <span>{{ thirdItem.name }}</span>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <!--客户录入 - 权限2显示 -->
      <div class="menu-section" v-if="checkAuth(2)">
        <div class="menu-title">客户录入</div>
        <div class="menu-item" :class="{ active: activeMenu === '客户录入' }" @click="goRouter('客户录入','/entry')">
          <img src="@/assets/entry.png" alt="">
          <span>客户录入</span>
        </div>
        <div class="menu-item" :class="{ active: activeMenu === '报备记录' }" @click="goRouter('报备记录','/entryRecord')">
          <img src="@/assets/record.png" alt="">
          <span>报备记录</span>
        </div>
      </div>

      <!-- 账户 - 始终显示 -->
      <div class="menu-section">
        <div class="menu-title">账户</div>
        <div class="menu-item" :class="{ active: activeMenu === '流水记录' }" @click="goRouter('流水记录','/balance')">
          <img src="@/assets/record.png" alt="">
          <span>流水记录</span>
        </div>
        <div class="menu-item logout" @click="logOut()">
          <img src="@/assets/exit.png" alt="">
          <span>退出登录</span>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
  import {
    newsCate,
    loginout,
    getBaseCofig,
    collectCate,
    trainingCate
  } from '@/api/api'

  export default {
    name: "Menu",
    data() {
      return {
        cate: [],
        activeMenu: "",
        config: {},
        cateids: '',
        collectCateList: [],
        collectCateListId: '',
        // 新增：权限缓存（只获取1次）
        userAuth: [],
        // 培训分类
        trainingCateData: [],
        // 培训分类id
        trainingCateId: ''
      }
    },
    mounted() {
      // 获取培训分类
      this.trainingCate()

      this.newsCate()
      this.getBaseConfig()
      this.collectCate()
    },
    watch: {
      $route(to) {
        this.cateids = '';
        // this.trainingCateId = '';
        if (to.path === '/entry') {
          this.activeMenu = '客户录入'
        }
        if (to.path === '/entryRecord') {
          this.activeMenu = '报备记录'
        }
        if (to.path === '/balance') {
          this.activeMenu = '流水记录'
        }
        if (to.path === '/defaultPath') {
          this.activeMenu = '默认学习路线'
        }
        if (to.path === '/studyPath') {
          const id = this.$route.query.id
          const target = this.collectCateList.find(item => item.id == id)
          this.activeMenu = target ? target.name : '';
          this.$forceUpdate()
        }
      }
    },
    methods: {
      /** 权限判断核心方法 */
      initUserAuth() {
        const authNode = JSON.parse(localStorage.getItem('userInfo')).auth_node || ''
        if (!authNode) {
          this.userAuth = []
          return
        }
        // 适配你的格式：",1,2," → 转成 [1,2]
        this.userAuth = authNode.split(',')
            .filter(item => item.trim() !== '') // 去掉空字符串
            .map(Number) // 转数字

        if (this.userAuth.length === 0) {
          this.activeMenu = '';
          this.trainingCateId = this.trainingCateData[0].id
          this.$router.push({path: '/training', query: {id: this.trainingCateId }})
        } else {
          const has1 = authNode.includes(1)
          const has2 = authNode.includes(2)

          if (has1 && has2) {
            // 同时有 1 + 2 → 首页
            this.activeMenu = '首页'
          } else if (has1) {
            // 只有 1 → 首页
            this.activeMenu = '首页'
          } else if (has2) {
            // 只有 2 → 客户录入还是选中培训 因为培训在客户录入的上方
            this.activeMenu = '';
            this.trainingCateId = this.trainingCateData[0].id
            this.$router.push({path: '/training', query: {id: this.trainingCateId }})
          }
        }
      },
      /** 【纯计算，无IO，极快】判断权限 */
      checkAuth(authCode) {
        return this.userAuth.includes(authCode)
      },
      /** 获取培训分类 */
      trainingCate() {
        trainingCate().then(res => {
          this.trainingCateData = res.data
          this.trainingCateData = this.trainingCateData.map(item => ({
            ...item,
            isExpanded: false,
            sub: item.sub ? item.sub.map(sub => ({
              ...sub,
              isExpanded: false,
              sub: sub.sub
            })) : []
          }))

          console.log(   this.trainingCateData)
          // 页面加载时，只执行1次获取权限
          this.initUserAuth()
        })
      },
      /** 培训分类选择事件 */
      trainingCateEvent(item, level) {
        this.trainingCateId = item.id
        this.activeMenu = '';
        this.cateids = '';
        if (level < 3 && item.sub && item.sub.length) {
          this.$set(item, 'isExpanded', !item.isExpanded)
        }
        this.$router.push({path: '/training', query: {id: item.id}})
      },
      /** 学习路线 */
      collectCate() {
        collectCate().then(res => {
          this.collectCateList = res.data.list
          this.collectCateList.unshift({name: '默认学习路线', id: 0})
        })
      },
      /** 获取分类 */
      newsCate() {
        newsCate().then(res => {
          this.cate = res.data
          this.cate = this.cate.map(item => ({
            ...item,
            isExpanded: false,
            sub: item.sub ? item.sub.map(sub => ({
              ...sub,
              isExpanded: false,
              sub: sub.sub
            })) : []
          }))
        })
      },
      /** 获取系统配置 */
      getBaseConfig() {
        getBaseCofig().then(res => {
          this.config = res.data
        })
      },
      /** 点击分类事件 */
      cateEvent(item, level) {
        this.cateids = item.id
        this.activeMenu = item.name
        if (level < 3 && item.sub && item.sub.length) {
          this.$set(item, 'isExpanded', !item.isExpanded)
        }
        let data = {
          activeMenu: this.activeMenu,
          cateids: this.cateids
        }
        if (this.$route.path !== '/referral') {
          this.activeMenu = ''
          this.$router.push({path: '/home'})
        }
        this.$emit('menuEvent', data)
      },
      /** 路由跳转 */
      goRouter(name, path) {
        this.activeMenu = name;
        this.cateids = '';
        this.trainingCateId = '';
        if (name === '首页') {
          let data = {
            activeMenu: this.activeMenu,
            cateids: ''
          }
          this.$emit('menuEvent', data)
        }
        this.$router.push({path: path})
      },
      /** 退出登录 */
      logOut() {
        loginout({token: localStorage.getItem('token')}).then(res => {
          this.$store.dispatch('logout')
          this.$message.success(res.info)
        })
      },
      /** 学习路线菜单 */
      goStudyPath(item) {
        this.trainingCateId = '';
        this.activeMenu = item.name;
        this.collectCateListId = item.id;
        this.$router.push({path: '/studyPath', query: {id: item.id}})
      }
    }
  }
</script>

<style scoped lang="less">
  .sidebar {
    width: 220px;
    background-color: #fff;
    padding: 24px 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 32px;
    overflow-y: auto;

    .sidebar-logo {
      display: flex;
      align-items: center;
      justify-content: center;

      .logo-circle {
        width: 120px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .logo-text {
        font-size: 20px;
        font-weight: 600;
        color: #3a44f7;
      }
    }

    .sidebar-menu {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .menu-title {
        font-size: 14px;
        font-weight: 500;
        color: #1e293b;
        margin-bottom: 8px;
        text-align: left;
      }

      .menu-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px 16px;
        border-radius: 8px;
        cursor: pointer;
        font-size: 14px;
        color: #64748b;
        transition: all 0.2s ease;
        position: relative;

        img {
          width: 20px;
          height: 20px;
          object-fit: cover;
          border-radius: 4px;
        }

        .arrow {
          margin-left: auto;
          font-size: 12px;
          transition: transform 0.3s ease;
          color: #94a3b8;

          &.expanded {
            transform: rotate(90deg);
          }
        }

        &.active {
          background-color: #2F3CED;
          color: #fff;

          .arrow {
            color: #fff;
          }
        }

        &:hover {
          background-color: #2F3CED;
          color: #fff;

          .arrow {
            color: #fff;
          }
        }

        &.sub-item {
          padding-left: 36px;
          font-size: 13px;

          img {
            width: 18px;
            height: 18px;
          }
        }

        &.level-3 {
          padding-left: 56px;
          font-size: 12px;

          img {
            width: 16px;
            height: 16px;
          }
        }
      }

      .sub-menu {
        overflow: hidden;
      }

      .slide-enter-active,
      .slide-leave-active {
        transition: all 0.3s ease;
        max-height: 500px;
        opacity: 1;
      }

      .slide-enter,
      .slide-leave-to {
        max-height: 0;
        opacity: 0;
      }

      .sub-menu {
        margin-top: 2px;
      }
    }
  }
</style>
